import { LoaderFunctionArgs } from "react-router-dom";
import { apiEndpoints } from "@/services/api/api";
import { BasePaginatedRequest } from "@/types/apiTypes/basePaginatedRequest";
import { AdminPanelPaginatedUserLoaderData } from "../types/adminPanelPaginatedUserLoaderData";

export async function adminPanelUserLoader({ request }: LoaderFunctionArgs): Promise<AdminPanelPaginatedUserLoaderData> {
    const url = new URL(request.url);
    const searchParams = url.searchParams;

    const paginatedRequest: BasePaginatedRequest = {
        pageNumber: parseInt(searchParams.get("page") || "1"),
        pageSize: 10,
        search: searchParams.get("search") || null,
        orderBy: "Email",
        desc: false
    };

    try {
        const response = await apiEndpoints.getUsers(paginatedRequest);

        return {
            users: response.data.items,
            totalPages: response.data.totalPageCount,
            currentPage: paginatedRequest.pageNumber,
            totalItems: response.data.totalItemCount,
            pageSize: response.data.items.length
        };
    } catch (error) {
        console.error("User loader error:", error);
        throw new Response("Kullanıcılar yüklenirken bir hata oluştu", {
            status: 500,
            statusText: "Internal Server Error"
        });
    }
}